import {ConstantsContainer} from "../helper/constants";
import axios from "axios";
import {RegexContainer} from "../helper/regex";

export const createCardTokenApi = (merchantReference, expiryDate, cardNumber) => {
    const createCardTokenUrl = `${ConstantsContainer.iveriPaymentBaseUrl}${ConstantsContainer.iveriPaymentEndpoint}`;

    return axios.post(createCardTokenUrl, {
        Version: "2.0",
        CertificateID: `${process.env.REACT_APP_CERTIFICATE_ID}`,
        ProductType: "Enterprise",
        ProductVersion: "WebAPI",
        Direction: "Request",
        Enquiry: {
            ApplicationID: `${process.env.REACT_APP_APPLICATION_ID}`,
            Command: "PANToken",
            Mode: `${process.env.REACT_APP_IVERI_TRANSACTION_MODE}`,
            MerchantReference: merchantReference,
            ExpiryDate: `${expiryDate.replace('/', '')}`,
            PAN: `${cardNumber.replace(RegexContainer.removeEmptySpaceRegex(), '')}`

        }
    }, {
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            "Accept": "application/json; charset=UTF-8"
        },
    })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error;
        })
}